var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"height":"18vw","autoplay":false}},_vm._l((_vm.images),function(item){return _c('el-carousel-item',{key:item.basicId},[_c('img',{attrs:{"src":_vm.$store.state.baseUrl+item.basicThumbnails}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }